import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=06cece8f&scoped=true&"
import script from "./customDialog.vue?vue&type=script&lang=js&"
export * from "./customDialog.vue?vue&type=script&lang=js&"
import style0 from "./customDialog.vue?vue&type=style&index=0&id=06cece8f&prod&lang=css&"
import style1 from "./customDialog.vue?vue&type=style&index=1&id=06cece8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cece8f",
  null
  
)

export default component.exports